import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { GroupsOutlined } from '@mui/icons-material';
import { StaffSection } from '../../../../../staff';
import { ZERDE_PRIMARY } from '../types';

interface UserStaffSectionProps {
  /** Точка, чьи сотрудники показываются */
  masterId: number;
}

/**
 * Сотрудники точки (PROJECT_NOTES §44). Карточка рендерит раздел, только если сервер вернул точку
 * в /api/v2/users-staff/counts: это кабинет, точка в зоне users.staff.view и ниже рангом оператора
 */
export const UserStaffSection: React.FC<UserStaffSectionProps> = ({ masterId }) => {
  return (
    <Box id="user-section-staff" sx={{ scrollMarginTop: '60px' }}>
      <Paper elevation={0} sx={{ p: 3.5, bgcolor: '#ffffff', borderRadius: '16px', border: '1px solid #e2e8f0', boxShadow: '0 2px 10px rgba(0,0,0,0.03)' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
          <GroupsOutlined sx={{ color: ZERDE_PRIMARY, fontSize: 20 }} />
          <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#0f172a' }}>
            Сотрудники точки
          </Typography>
        </Box>
        <Typography variant="body2" sx={{ color: '#64748b', mb: 3 }}>
          Учётки сотрудников входят под логином точки с суффиксом и видят только выданные им разделы
        </Typography>

        <StaffSection mode="admin" masterId={masterId} />
      </Paper>
    </Box>
  );
};

export default UserStaffSection;
